module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/components/Squad/images/locked-slot.caf70554.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/Squad/images/locked-slot.png
// module id = 2742
// module chunks = 11